import { useState, useCallback, useEffect, useRef } from 'react'
import { useSignupSession } from './useSignupSession'

export const useFetchAutofillAddresses = () => {
  const { instantInkService } = useSignupSession()
  const [cache, setCache] = useState({})
  const isMountedRef = useRef(true)

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  return useCallback(
    async (param, partialSubscriptionId) => {
      if (cache[param]) {
        return cache[param]
      } else {
        try {
          if (instantInkService) {
            const { data } = await instantInkService.fetchAutofillAddresses(
              param,
              partialSubscriptionId
            )
            if (!isMountedRef.current) return data
            setCache((prevCache) => ({ ...prevCache, [param]: data }))
            return data
          }
        } catch (error) {
          console.error(error)
        }
      }
    },
    [cache, instantInkService]
  )
}
